// Root app — provider tunggal (Auth -> Branch -> Theme -> Shift) + router +
// Toaster. Branch di atas Shift: shift bersifat per-cabang aktif (RFC-007).

import { Toaster } from "@ds/ui";
import { AuthProvider } from "../lib/auth";
import { BranchProvider } from "../lib/branch";
import { ThemeProvider } from "../lib/theme";
import { ShiftProvider } from "../lib/shift";
import { AppRouter } from "./router";
import { OutboxSync } from "./OutboxSync";

export function App() {
  return (
    <AuthProvider>
      <BranchProvider>
        <ThemeProvider>
          <ShiftProvider>
            <OutboxSync />
            <AppRouter />
            <Toaster />
          </ShiftProvider>
        </ThemeProvider>
      </BranchProvider>
    </AuthProvider>
  );
}
